import { Amount } from '~/components/amount'
import { Flex } from '~/components/layout'
import { Text } from '~/components/typography'
import { colors } from '~/styles/colors'
import { AmountText } from './style'
import { Avatar } from '~/components/avatar'
import { PageBySlugQuery } from '~/graphql/page-by-slug'

type Props = {
  fundraiser: PageBySlugQuery['pageBySlug']['fundraisers'][0]
}

const FundraiserDetail = ({ fundraiser }: Props) => {
  return (
    <Flex
      flexDirection="column"
      alignItems="center"
      padding="40px 0 0"
      border={colors.border}
      style={{ borderRadius: 2 }}
    >
      {fundraiser.profilePictureUrl && (
        <Avatar
          size={96}
          user={{ profilePictureUrl: fundraiser.profilePictureUrl }}
          marginBottom={14}
        />
      )}
      <Text bold marginBottom={28}>
        {fundraiser.name}
      </Text>
      <Flex
        width={1}
        padding="18px 28px"
        justifyContent="space-between"
        alignItems="center"
        borderTop={colors.border}
      >
        <Text bold>Raised</Text>
        <AmountText>
          <Amount>{fundraiser.raised}</Amount>
        </AmountText>
      </Flex>
    </Flex>
  )
}

export default FundraiserDetail
